import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  url;
  constructor(private http: HttpClient ) {
    this.url = environment.baseApiUrl + 'api/';
  }

  public connect(data) {
    const headers = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'});
    return this.http.post(this.url + 'contact-us', data, {headers}).pipe(
      map(
        (response: HttpResponse<any>) => {
          return response;
        }
      )
    );
  }

}
